import { z } from 'zod';

// Schéma pour le delta jsondiffpatch (structure flexible)
export const TranscriptDeltaSchema = z.record(z.unknown());

export const PatchTranscriptSchema = z.object({
  delta: TranscriptDeltaSchema,
});

export type TranscriptDelta = z.infer<typeof TranscriptDeltaSchema>;
export type PatchTranscript = z.infer<typeof PatchTranscriptSchema>;
